import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gou",
  "use": "icon-gou-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-gou\"><path d=\"M940.8 169.6c-12.8 0-25.6 6.4-35.2 16l-534.4 544-249.6-256c-9.6-9.6-22.4-16-38.4-16-28.8 0-51.2 22.4-51.2 51.2 0 16 6.4 28.8 16 38.4l284.8 291.2c9.6 9.6 22.4 16 35.2 16 12.8 0 25.6-6.4 35.2-16L976 259.2c9.6-9.6 16-22.4 16-38.4 0-28.8-22.4-51.2-51.2-51.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/gou.svg
// module id = gRz4
// module chunks = 16